import React, { ChangeEvent, useState } from "react";
import { InputAdornment, TextField } from "@mui/material";
import { Search } from "@mui/icons-material";
import { useDispatch, useSelector } from "../../store";
import { setReportFilter } from "../../slices/report";
import { useNavigate } from "react-router-dom";

const NavbarSearch: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { reportFilter } = useSelector((store) => store.report);
  const [search, setSearch] = useState("");

  const handleSearch = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setSearch(e.target.value);
    dispatch(setReportFilter({ ...reportFilter, query: e.target.value }));
  };

  const handleSubmit = () => {
    navigate("/reports");
    setSearch("");
  };

  return (
    <TextField
      autoComplete="off"
      size={"small"}
      placeholder={"Search"}
      variant={"outlined"}
      inputProps={{
        "data-form-type": "other",
        "data-lpignore": " true",
      }}
      fullWidth
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment
              position="end"
              onClick={handleSubmit}
              sx={{
                cursor: "pointer",
              }}
            >
              <Search />
            </InputAdornment>
          ),
          autoComplete: "off",
        },
      }}
      value={search}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          handleSubmit();
        }
      }}
      onChange={(e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
        handleSearch(e)
      }
    />
  );
};

export default NavbarSearch;
